import b from "./index.es92.js";
const g = [
  "#5b1DE6",
  "#F594A0",
  "#8CBDF0",
  "#007A86",
  "#dbae37",
  "#8d230f",
  "#fb6542",
  "#ffe000",
  "#6ab187",
  "#d93304",
  "#5f3f6b",
  "#c48bc2",
  "#98DBC6"
], i = [
  "#fff",
  "#000",
  "#000",
  "#fff",
  "#000",
  "#fff",
  "#000",
  "#000",
  "#000",
  "#fff",
  "#fff",
  "#000",
  "#000"
], h = [
  "zigzag-vertical",
  "dot",
  "diagonal-right-left",
  "box",
  "dash",
  "diamond-box",
  "disc",
  "line",
  "dot-dash",
  "cross",
  "diagonal"
], p = (t = {}) => {
  const o = t.colors || g, s = t.patternColors || i, r = t.patterns || h, f = (e) => {
    const n = e.datasetIndex;
    if (n < o.length)
      return o[n];
    const a = n % o.length, l = n % r.length;
    return b.draw(
      r[l],
      o[a],
      s[a]
    );
  }, d = t.borders || [], c = t.borders && t.borders.length ? (e) => {
    const n = e.datasetIndex;
    return d[n % d.length];
  } : f;
  return {
    background: f,
    border: c,
    colorString: (e) => o[e % o.length]
  };
};
export {
  p as createBackgroundColorFunctions
};
//# sourceMappingURL=index.es362.js.map
